import Data from './data'

export default {
    list: () => [200, Data.list],
    get: () => [200, Data.get],
}
